import React from "react";

const ApparelFinishedProductsIcon = ({
  color = "#5D5D5D",
  width = "23",
  height = "23",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2985_11359)">
        <path
          d="M8.35513 1.80155V1.27734L1.0166 3.37418L2.06492 9.14018H5.21008V21.7206H17.7905V9.14018H20.9357L21.984 3.37418L14.6454 1.27734V1.80155C14.6454 4.22269 12.0245 5.73589 9.92776 4.52533C8.95467 3.96355 8.35513 2.9252 8.35513 1.80155Z"
          stroke={color}
          strokeWidth="1.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_2985_11359">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ApparelFinishedProductsIcon;
